<script lang="ts">
    import {Calendar, type EventClickArg} from '@fullcalendar/core';
    import dayGridPlugin from '@fullcalendar/daygrid';
    import listPlugin from "@fullcalendar/list";
    import {onMount} from "svelte";
    import {Badge, Button, Modal} from "flowbite-svelte";
    import dayjs from "dayjs";
    import relativeTime from "dayjs/plugin/relativeTime";
    import 'dayjs/locale/de'
    import type {CalendarProps} from "$lib/types/calender";
    import {EventImpl} from "@fullcalendar/core/internal";

    dayjs.extend(relativeTime)
    dayjs.locale('de')

    let calendarElement: HTMLElement;
    export let calendar: Calendar | null = null;
    let openModal = false;

    let activeProp: CalendarProps;

    function handleEventClick(info: EventClickArg) {
        if ('type' in info.event.extendedProps) {
            activeProp = info.event.extendedProps as CalendarProps;
        }
        openModal = true;
    }

    let eventStore:any[] = [];

    onMount(() => {
        calendar = new Calendar(calendarElement, {
            plugins: [dayGridPlugin, listPlugin],
            eventClick: handleEventClick,
            initialView: 'listDay',
            customButtons: {
                filterOnlyTelephone: {
                    text: 'Telefontermine',
                    click: function() {
                        eventStore.forEach(cEvent => {
                            calendar?.addEvent(cEvent)
                        })
                        eventStore = [];
                        calendar?.getEvents().forEach((event: EventImpl) => {
                            if (!event.title.includes('Telefontermin')) {
                                eventStore.push({...event.toPlainObject()});
                                event.remove();
                            }
                        })
                    }
                },
                filterOnlyCandidateDate: {
                    text: 'Stammdaten',
                    click: function() {
                        eventStore.forEach(cEvent => {
                            calendar?.addEvent(cEvent)
                        })
                        eventStore = [];
                        calendar?.getEvents().forEach((event: EventImpl) => {
                            if (!event.title.includes('Stammdatenblatt')) {
                                eventStore.push({...event.toPlainObject()});
                                event.remove();
                            }
                        })
                    }
                },
                filterOnlyGet2Know: {
                    text: 'Get-to-know',
                    click: function() {
                        eventStore.forEach(cEvent => {
                            calendar?.addEvent(cEvent)
                        })
                        eventStore = [];
                        calendar?.getEvents().forEach((event: EventImpl) => {
                            if (!event.title.includes('get-to-know')) {
                                eventStore.push({...event.toPlainObject()});
                                event.remove();
                            }
                        })
                    }
                }
            },
            headerToolbar: {
                center: 'filterOnlyTelephone filterOnlyCandidateDate filterOnlyGet2Know',
                end: 'listDay dayGridWeek dayGridMonth prev,today,next'
            },
            height: 'auto'
            // options here
        });

        calendar.render();
    });

</script>

<div class="w-full h-min" bind:this={calendarElement}/>

{#if activeProp}
    <Modal
            title={activeProp.title}
            bind:open={openModal}>

        {#if activeProp.type === "employeeReminders"}
            <!--// type and the full information; will display: note, date (due, use Updated at), done or not, employee name-->
            <div class="flex flex-row justify-between items-start">
                <div class="font-bold">{@html activeProp.object.note}</div>
                {#if activeProp.object.doneAt?.value}
                    <Badge class="ml-2" color="green">{dayjs.unix(activeProp.object.doneAt.stamp).fromNow()} erledigt</Badge>
                {:else}
                    <Badge class="ml-2" color="red">Offen</Badge>
                {/if}
            </div>
            <div class="flex flex-row justify-between">
                <span class="font-bold">Employee</span>
                <a class="text-primary-700 hover:text-primary-500" href="/employee/{activeProp.object.employee.uuid}">{activeProp.object.employee.firstName} {activeProp.object.employee.lastName}</a>
            </div>
            <div class="flex flex-row justify-between">
                <span class="font-bold">Fällig</span>
                <span >{dayjs.unix(activeProp.object.remindAt.stamp).format('DD.MM.YYYY HH:mm')}</span>
                <span>{dayjs.unix(activeProp.object.remindAt.stamp).fromNow()}</span>
            </div>
        {/if}

        {#if activeProp.type === "waitingForHr"}
            <div class="flex flex-row justify-between">
                <span class="font-bold">Employee</span>
                <a class="text-primary-600 hover:text-primary-700" href="/employee/{activeProp.object.contract.employee.uuid}">{activeProp.object.contract.employee.name}</a>
            </div>
            <Button href="{activeProp.object?.contractDocument?.location}" target="_blank" color="primary">Contract
            </Button>
        {/if}
    </Modal>
{/if}
